<template>
  <div class="flex flex-col flex-1 overflow-y-auto w-full p-2">
    <div
      class="flex flex-1 grid grid-cols-8 overflow-y-auto w-full gap-4 rounded-xl"
    >
      <div class="flex flex-col col-span-5 gap-4 overflow-y-auto">
        <div class="bg-white p-2">
          <div class="flex items-center justify-between gap-2 mb-2">
            <h2 class="text-xs text-primary-900">
              {{ $t("monitor.call_tab") }}
            </h2>
            <FilterSelect
              v-model="selectedSkill"
              :options="skillOptions"
              :label="$t('reports.filters.select_skill')"
              id="dashboard-queue-options"
              :all-option="{ value: 0, label: $t('reports.filters.all') }"
            />
          </div>
          <calls-chart :skill="selectedSkill" />
        </div>
        <div class="grid grid-cols-3 mt-5">
          <customer-satisfaction :kpi="satisfaction" />
          <first-call-resolution :kpi="fcr" />
          <service-level :kpi="serviceLevel" />
          <abandoned-rate :kpi="abandonment" />
          <avg-handle-time :kpi="handleTime" />
          <avg-wait-time :kpi="callWait" />
        </div>
      </div>

      <div class="col-span-3 gap-4 flex flex-col flex-1 overflow-y-auto">
        <div class="grid grid-cols-5 col-span-3">
          <info-card
            :title="$t('home.calls_count')"
            :count="totalCalls"
            icon="mdi-phone-outline"
            :subtitle="''"
          ></info-card>
          <info-card
            :title="$t('home.incoming_calls')"
            :count="incoming_calls || 0"
            :subtitle="''"
            icon="mdi-clock-outline"
          ></info-card>
          <info-card
            :title="$t('home.outgoing_calls')"
            :count="outgoing_calls || 0"
            :subtitle="''"
            icon="mdi-clock-outline"
          ></info-card>
          <info-card
            :title="$t('home.answered_calls')"
            :count="answered"
            :subtitle="''"
            icon="mdi-phone-check-outline"
          ></info-card>
          <info-card
            :title="$t('home.abandoned_calls')"
            :count="abandoned"
            :subtitle="''"
            icon="mdi-phone-remove-outline"
          ></info-card>
          <info-card
            :title="$t('monitor.current_calls')"
            :count="callsData?.incoming_talking || 0"
            icon="mdi-phone-in-talk-outline"
            :subtitle="''"
          ></info-card>
          <info-card
            :title="$t('monitor.current_waiting')"
            :count="callsData?.incoming_waiting || 0"
            :subtitle="''"
            icon="mdi-phone-settings-outline"
          ></info-card>
          <info-card
            :title="$t('monitor.current_agents')"
            :count="agentsData?.agents || 0"
            icon="mdi-phone-in-talk-outline"
            :subtitle="''"
          ></info-card>
          <info-card
            :title="$t('home.average_speed_of_answer')"
            :count="avgSpeed"
            :subtitle="''"
            icon="mdi-clock-outline"
          ></info-card>
          <info-card
            :title="$t('home.average_talk_time')"
            :count="avgTalk"
            :subtitle="''"
            icon="mdi-clock-outline"
          ></info-card>
        </div>
        <agents-chart :agents-list="agentsList" :agents-stats="agentsData" />
        <div
          class="grid grid-cols-2 2xl:grid-cols-3 gap-4 mt-5 flex flex-col overflow-y-auto"
        >
          <call-card
            v-for="call in callsList.filter((call) => call.status !== 2)"
            :key="call.callid"
            :active-call="call"
            :agents-list="agentsList"
          />
          <div
            v-if="callsList.filter((call) => call.status !== 2).length === 0"
            class="col-span-4"
          >
            <Vue3Lottie
              :animationData="LottieAnimation"
              :autoPlay="true"
              :loop="true"
              :speed="1"
              class="2xl:!h-[200px] !h-[150px]"
            />
            <p class="text-center text-gray-500">
              {{ $t("monitor.no_calls") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InfoCard from "@/components/InfoCard.vue";
import AbandonedRate from "./components/AbandonedRate.vue";
import FirstCallResolution from "./components/FirstCallResolution.vue";
import CustomerSatisfaction from "./components/CustomerSatisfaction.vue";
import ServiceLevel from "./components/ServiceLevel.vue";
import AvgWaitTime from "./components/AvgWaitTime.vue";
import AvgHandleTime from "./components/AvgHandleTime.vue";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import LottieAnimation from "@/assets/relaxing_animation.json";
import { Vue3Lottie } from "vue3-lottie";
import CallCard from "@/pages/monitor/components/CallCard.vue";
import AgentsChart from "@/pages/monitor/components/AgentsChart.vue";
import CallsChart from "@/pages/monitor/components/CallsChart.vue";
import FilterSelect from "@/pages/reports/components/filters/FilterSelect.vue";
export default {
  name: "agentHome",
  components: {
    InfoCard,
    AbandonedRate,
    FirstCallResolution,
    CustomerSatisfaction,
    ServiceLevel,
    AvgWaitTime,
    AvgHandleTime,
    Vue3Lottie,
    CallCard,
    AgentsChart,
    CallsChart,
    FilterSelect,
  },
  data() {
    return {
      loading: false,
      period: "1",
      dashBoardInterval: null,
      totalCalls: 0,
      fcrCount: 0,
      answered: 0,
      abandoned: 0,
      avgTalk: "00:00",
      avgWait: "00:00",
      avgSpeed: "00:00",
      avgHandletime: "00:00",
      abandonment: null,
      fcr: null,
      satisfaction: null,
      serviceLevel: null,
      handleTime: null,
      callWait: null,
      callsList: [],
      agentsList: [],
      agentsData: {
        agents: 0,
        idle: 0,
        rest: 0,
        busy: 0,
        offline: 0,
      },
      LottieAnimation: LottieAnimation,
      callsData: {
        incoming_talking: 0,
        incoming_waiting: 0,
      },
      skills: [],
      selectedSkill: 0,
      incoming_calls: 0,
      outgoing_calls: 0,
    };
  },
  methods: {
    ...mapActions([
      "GetDomainSkills",
      "GetMainSummary",
      "GetKPIStats",
      "ShowProgressBar",
      "SetMessageDialog",
      "GetSkillsMonitor",
    ]),

    async initHome() {
      await this.GetDomainSkills();
      this.skills = this.domainSkills.map((skill) => {
        return skill.name;
      });
      await this.doSkillsCallsAgentsMonitor();
      await this.setupDashboard(true);
      this.dashBoardInterval = setInterval(async () => {
        await this.setupDashboard();
        await this.doSkillsCallsAgentsMonitor();
      }, 10000);
      this.$store.commit("setAdminDashboardInterval", this.dashBoardInterval);
    },
    async setupDashboard(progress) {
      try {
        this.ShowProgressBar({
          show: progress,
        });
        const request = {
          from: `${moment().format("YYYY-MM-DD")} 00:00:00`,
          to: `${moment().format("YYYY-MM-DD")} 23:59:59`,
          skill: this.selectedSkill,
        };
        var resp = await this.GetMainSummary(request);
        if (!resp.success) {
          this.ShowProgressBar({ show: false, message: "" });
          // this.SetMessageDialog({ show: true, message: resp.message });

          return;
        }
        this.totalCalls = resp.summary.incoming + resp.summary.outgoing;
        this.avgTalk = resp.summary.avgTalk || "00:00";
        this.avgWait = resp.summary.avgWait || "00:00";
        this.avgSpeed = resp.summary.avgSpeedAns || "00:00";
        this.answered = resp.summary.incoming - resp.summary.notAnswered;
        this.abandoned = resp.summary.notAnswered;
        this.fcrCount = resp.summary.fcr;
        this.incoming_calls = resp.summary.incoming;
        this.outgoing_calls = resp.summary.outgoing;
        resp = await this.GetKPIStats(request);
        if (!resp.success) {
          this.ShowProgressBar({ show: false, message: "" });
          // this.SetMessageDialog({ show: true, message: resp.message });

          return;
        }
        this.abandonment = this.resolveKpiForSkill(resp.KPIs.abandonment);
        this.fcr = this.resolveKpiForSkill(resp.KPIs.fcr);

        this.handleTime = this.resolveKpiForSkill(resp.KPIs.handle_time);
        this.satisfaction = this.resolveKpiForSkill(resp.KPIs.satisfaction);
        this.serviceLevel = this.resolveKpiForSkill(resp.KPIs.answer_rate);
        this.callWait = this.resolveKpiForSkill(resp.KPIs.wait_time);
        this.avgHandletime = moment()
          .startOf("day")
          .seconds(+this.handleTime.sla)
          .format("mm:ss");
        this.ShowProgressBar({ show: false, message: "" });
      } catch (err) {
        this.ShowProgressBar({ show: false, message: "" });

        // let message = err.message;
        // if (err.response) {
        //   message = err.response.data.message;
        // }
        // this.SetMessageDialog({ show: true, message: message });
      }
    },
    getPeriodStartEnd() {
      let request;
      if (this.period == "2") {
        request = {
          from: moment()
            .subtract(3, "h")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString(),
          to: moment().format("YYYY-MM-DD HH:mm:ss").toString(),
        };
      } else if (this.period == "3") {
        request = {
          from: moment()
            .subtract(1, "h")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString(),
          to: moment().format("YYYY-MM-DD HH:mm:ss").toString(),
        };
      } else {
        request = {
          from: moment()
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss")
            .toString(),
          to: moment().format("YYYY-MM-DD HH:mm:ss").toString(),
        };
      }

      return request;
    },
    resolveKpiForSkill(kpi) {
      if (!kpi) return kpi;
      if (!this.selectedSkill || this.selectedSkill === "0") return kpi;
      const match = (kpi.skills || []).find(
        (s) => s.name === this.selectedSkill
      );
      return { ...kpi, sla: match ? match.sla : 0 };
    },
    async doSkillsCallsAgentsMonitor() {
      try {
        const skillsToMonitor =
          this.selectedSkill && this.selectedSkill !== "0"
            ? [this.selectedSkill]
            : this.skills;
        var resp = await this.GetSkillsMonitor(skillsToMonitor);
        if (resp && resp.result) {
          let result = resp.result;
          this.agentsData = result.total || this.agentsData;
          this.callsData = result.total || this.callsData;
          let agents = result.agents ? result.agents.reverse((a, b) => {
            return a - b;
          }) : [];
          this.agentsList = agents;
          let calls = result.calls ? result.calls.reverse(function (a, b) {
            return a.duration.localeCompare(b.duration);
          }) : [];
          this.callsList = calls;
        }
      } catch (error) {
        console.error('Error in doSkillsCallsAgentsMonitor:', error);
        // Keep existing data if there's an error
      }
    },
  },
  computed: {
    ...mapGetters(["domain", "domainSkills"]),
    skillOptions() {
      const isAr = this.$i18n.locale === "ar";
      return (this.domainSkills || []).map((skill) => ({
        value: skill.name,
        label: skill.titles ? (isAr ? skill.titles.ar : skill.titles.en) : skill.name,
      }));
    },
  },
  watch: {
    async domain(newValue) {
      if (newValue) {
        await this.initHome();
      }
    },
    async period(value) {
      if (["1", "2", "3"].includes(value)) {
        await this.setupDashboard(true);
      }
    },
    async selectedSkill() {
      await this.setupDashboard(true);
      await this.doSkillsCallsAgentsMonitor();
    },
  },
  async mounted() {
    if (this.domain) {
      await this.initHome();
    }
  },
  beforeUnmount() {
    if (this.dashBoardInterval) {
      clearInterval(this.dashBoardInterval);
      this.dashBoardInterval = null;
    }
  },
};
</script>
